import { useProfitData } from '../../hooks/useProfitData'
import { formatCurrency, getValueColor } from '../../utils/formatCurrency'
import { useT } from '../../hooks/useTranslation'

export default function StatsCards() {
  const { today, yesterday } = useProfitData()
  const t = useT()

  // «Сегодня» и «Вчера» ВСЕГДА показываются со знаком (+/-) и цветом
  // прибыли/убытка — по одному коду для обеих карточек, без флагов.
  const cards = [
    { label: t.statToday,     value: today },
    { label: t.statYesterday, value: yesterday },
  ]

  return (
    <div className="grid grid-cols-2 gap-2 mb-4">
      {cards.map(({ label, value }) => (
        <div
          key={label}
          className="flex flex-col gap-1 rounded-xl p-3"
          style={{ background: '#1A1A1A' }}
        >
          <span className="text-[11px]" style={{ color: '#8E8E93' }}>{label}</span>
          <span className="text-[15px] font-semibold" style={{ color: getValueColor(value) }}>
            {formatCurrency(value, true)}
          </span>
        </div>
      ))}
    </div>
  )
}
